import React from 'react'
import { Button, Icon } from '@opallabs/lapidary'
import { buttonOverride, noOutlineStyles } from './styles'

type AddContentButtonProps = {
  collapsed?: boolean
  disabled: boolean
  hideButtonText?: boolean
  isOutlined: boolean
  onClickAdd?: () => void
  onBlur?: () => void
  onFocus?: () => void
  popoverOpened?: boolean
}

export const BUTTON_CLASS = 'add-content-popover'

export const AddContentButton = React.forwardRef<
  HTMLButtonElement,
  AddContentButtonProps
>((props: AddContentButtonProps, ref) => {
  const {
    collapsed = false,
    disabled,
    hideButtonText = false,
    isOutlined,
    onClickAdd = () => null,
    onBlur,
    onFocus,
    popoverOpened = false,
  } = props
  const additionalStyles = isOutlined ? {} : noOutlineStyles

  return (
    <Button
      buttonText="Add Content"
      variant="tertiary"
      className={BUTTON_CLASS}
      disabled={disabled}
      displayMenuIndicator={true}
      hideButtonText={collapsed || hideButtonText}
      menuIndicator={<Icon ariaHidden glyph="gem-add" height={12} width={12} />}
      name="Add Content to Moment"
      overrideStyles={{
        ...buttonOverride(disabled, collapsed, hideButtonText, popoverOpened),
        ...additionalStyles,
      }}
      onClick={onClickAdd}
      onBlur={onBlur}
      onFocus={onFocus}
      ref={ref}
      tabIndex={0}
    />
  )
})
AddContentButton.displayName = 'AddContentButton'
